import React from "react";
import styles from "./TrustBuildCard.module.scss";
//import cx from "classnames";
import heart from "images/Heart.png";
import star from "images/Star.png";
import trophy from "images/Trophy.png";

export const TrustBuildCard: React.FC = () => {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.title}>The MyEyeDr. Difference</div>
        <div className={styles.list}>
          <img src={star} alt="" className={styles.icon} />
          100,000+ Five-Star Reviews
        </div>
        <div className={styles.list}>
          <img src={heart} alt="" className={styles.icon} />
          Voted 'Best in Customer Service' by Newsweek
        </div>
        <div className={styles.list}>
          <img src={trophy} alt="" className={styles.icon} />
          Award-Winning Optometrists
        </div>
      </div>
    </>
  );
};
